import {
	ProductKeys,
	type ProductKeys1P,
	type ProductKeys3P,
} from '../../../../../common/constants/products';
import { getProducts3PFromConfigForFilter } from '../../../../../common/utils/filters';
import { createBooleanFilter } from '../../../../filters/boolean-filter';

const productKeys1P: ProductKeys1P[] = [ProductKeys.Confluence];

const products3PFromConfig: ProductKeys3P[] = getProducts3PFromConfigForFilter('archived');

export const filter: Readonly<{
    id: "archived";
    type: "boolean";
    queryParams: {
        key: string;
    };
    products: ProductKeys[];
    universal: boolean;
    customValueFields?: string[];
    withState: (state: unknown, config: import("../../../../../common/constants/filters/cloud-config/types").CloudConfig) => import("../../../../../common/constants/filters/boolean-filter/types").BooleanFilterMonad<"archived">;
    getInitialState: (config: import("../../../../../common/constants/filters/cloud-config/types").CloudConfig) => import("../../../../../common/constants/filters/boolean-filter/types").BooleanFilterMonad<"archived">;
    isCompatible: (filterId?: string) => boolean;
    isSupportCustomValue: boolean;
    isSuggestedFilter?: (primaryProduct?: string) => boolean;
}> = createBooleanFilter({
	id: 'archived',
	queryParams: { key: 'archived' },
	products: [...productKeys1P, ...products3PFromConfig],
	alwaysVisible: true,
	universal: false,
});
